// index.html is served with Cache-Control: public, max-age=300 (see webapp Makefile
// `deploy` target) so browsers can serve it straight from disk cache on a plain
// reload() without hitting the network — the update toast/chunk-load-error reload
// would then re-render the same stale bundle. Navigating to a cache-busted URL
// forces a real network fetch of the current index.html.
export const forceReload = () => {
  const url = new URL(window.location.href);
  url.searchParams.set("_r", Date.now());
  window.location.replace(url.toString());
};
